import React from 'react';

const ErrorPage = () => (
    <div className="errorPage">
        <h3>404 page not found</h3>
        <p>We are sorry but the page you are looking for does not exist.</p>
    </div>
);

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/components/errorPage/index.js